import { defineMessages } from '@/i18n';

export const artworkDigitalDossierMessages = defineMessages({
  title: 'platform.app.gallery.artworks.digitalDossier.title',
  subtitle: 'platform.app.gallery.artworks.digitalDossier.subtitle',
  subtitleEmpty: 'platform.app.gallery.artworks.digitalDossier.subtitleEmpty',
  newDocuments: 'platform.app.gallery.artworks.digitalDossier.newDocuments',
  uploadModalTitle: 'platform.app.gallery.artworks.digitalDossier.uploadModal.title',
  editModalTitle: 'platform.app.gallery.artworks.digitalDossier.editModal.title',
  uploadModalLabel: 'platform.app.gallery.artworks.digitalDossier.uploadModal.label',
  uploadModalTitleCancelBtn: 'platform.app.gallery.artworks.digitalDossier.uploadModal.cancelBtn',
  uploadModalTitleSubmitBtn: 'platform.app.gallery.artworks.digitalDossier.uploadModal.submitBtn',
  uploadModalDocumentTitleLabel: 'platform.app.gallery.artworks.digitalDossier.uploadModal.documentTitleLabel',
  uploadModalDocumentTypeLabel: 'platform.app.gallery.artworks.digitalDossier.uploadModal.documentTypeLabel',
  uploadModalDocumentFileValidator: 'platform.app.gallery.artworks.digitalDossier.uploadModal.documentFileValidator',
  accountSettings: 'platform.app.gallery.artworks.digitalDossier.uploadModal.accountSettings',
  coaImageRequirements: 'platform.app.gallery.artworks.digitalDossier.uploadModal.coaImageRequirements',
  coaImageUploadOption: 'platform.app.gallery.artworks.digitalDossier.uploadModal.coaImageUploadOption',
  coaSignDocumentBtn: 'platform.app.gallery.artworks.digitalDossier.uploadModal.coaSignDocumentBtn',

  digitalPortfolioOnMastersNoteTitle: 'platform.app.gallery.artworks.digitalDossier.mastersNote.title',
  digitalPortfolioOnMastersNoteContent: 'platform.app.gallery.artworks.digitalDossier.mastersNote.content',

  // documents section
  documentsTitle: 'platform.app.gallery.artworks.digitalDossier.documents.title',
  supportingDocumentsTitle: 'platform.app.gallery.artworks.digitalDossier.documents.supportingDocument',
  documentsAddBtn: 'platform.app.gallery.artworks.digitalDossier.documents.addBtn',
  documentsSubtitle: 'platform.app.gallery.artworks.digitalDossier.documents.subtitle',

  // coa section
  coaTitle: 'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.title',
  coaTitleShort: 'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.titleShort',
  coaAddBtn: 'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.addBtn',
  coaSubtitle: 'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.subtitle',
  coaFirstSignature: 'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.firstSignature',
  coaSecondSignature: 'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.secondSignature',
  coaSecondSignatureDescription:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.secondSignatureDescription',

  // coa create modal
  coaCreateModalTitle: 'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.createModal.title',
  coaCreateModalSubtitle: 'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.createModal.subtitle',
  coaCreateModalSendForSignature:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.createModal.sendForSignatureBtn',
  coaCreateModalPreview:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.createModal.previewBtn',
  coaCreateModalNameLabel:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.createModal.nameLabel',
  coaCreateModalEmailSameAsOwnerError:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.createModal.emailSameAsOwnerError',
  coaCreateModalWarningNote:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.createModal.warning',

  //coa sign modal
  coaUnverifiedSignerTitle:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.signerModal.unverified.title',
  coaUnverifiedSignerDescription:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.signerModal.unverified.description',
  coaVerifiedSignerDescription:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.signerModal.verified.description',
  coaMintedSignerDescription:
    'platform.app.gallery.artworks.digitalDossier.certificateOfAuthenticity.signerModal.minted.description',

  //resale terms
  resaleTermsTitle: 'platform.app.gallery.artworks.digitalDossier.resaleTerms.title',

  // coa delete dialog
  coaDeleteDialogTitle: 'platform.app.gallery.artworks.digitalDossier.deleteCOA.title',
  coaDeleteDialogQuestion: 'platform.app.gallery.artworks.digitalDossier.deleteCOA.subtitle',
  documentDeleteSubtitle: 'platform.app.gallery.artworks.digitalDossier.deleteDocument.subtitle',
  //transfer of ownership
  transferOfOwnershipTitle: 'platform.app.gallery.artworks.digitalDossier.transferOfOwnership.title',
  blockchainRecord: 'platform.app.gallery.artworks.digitalDossier.transferOfOwnership.blockChainRecord',
});
